import * as React from 'react';

import { MarkdownText } from '@/components/common/MarkdownText';

interface TaskDescriptionProps {
  description: string;
}

export const TaskDescription: React.FC<TaskDescriptionProps> = ({
  description,
}) => (
  <MarkdownText
    content={description}
    className="text-xs text-slate-900 font-semibold"
    plainTextClassName="whitespace-pre-wrap"
    markdownClassName="prose prose-sm max-w-none prose-slate prose-p:my-2 prose-headings:my-2 prose-ul:my-2 prose-ol:my-2 prose-li:my-1 prose-code:text-xs prose-code:bg-slate-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded"
  />
);
